import React from "react"
import { motion } from "framer-motion"
import {
  BarChart,
  Bar,
  Cell,
  LabelList,
  XAxis,
  ResponsiveContainer,
} from "recharts"
import styles from "./question.module.css"

export default props => {
  const { type, feedback, stats, statsError, statsLoading, source } = props
  let stat1 = 0
  let stat2 = 0

  if (type === "polling") {
    const total = stats.stat1 + stats.stat2
    stat1 = Math.round((stats.stat1 * 100) / total)
    stat2 = Math.round((stats.stat2 * 100) / total)
  } else {
    stat1 = Math.round((stats.stat1 * 100) / stats.stat2)
    stat2 = stats.stat2
  }

  const chartData = [
    { name: "For it", percentage: stat1 },
    { name: "Against it", percentage: stat2 },
  ]
  const chartColors = ["#00a8cc", "#f35588"]

  return (
    <motion.div
      className={styles.feedback}
      initial={{ y: -15, opacity: 0.5 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 1 }}
    >
      {type === "polling" && (
        <div className={styles.pollingChart}>
          <ResponsiveContainer>
            <BarChart
              data={chartData}
              // margin={{ top: 5, right: 20, left: 10, bottom: 5 }}
            >
              <XAxis
                dataKey="name"
                interval={0}
                tick={{ fontSize: ".65rem" }}
                tickLine={false}
                axisLine={false}
              />
              <Bar dataKey="percentage">
                <LabelList
                  dataKey="percentage"
                  position="inside"
                  formatter={v => `${v}%`}
                  fill="#fff"
                  fontSize=".75rem"
                />
                {chartData.map((entry, index) => (
                  <Cell key={`cell-${index}`} fill={chartColors[index]} />
                ))}
              </Bar>
            </BarChart>
          </ResponsiveContainer>
        </div>
      )}
      <div
        className={styles.text}
        dangerouslySetInnerHTML={{ __html: feedback }}
      />
      {source && source.label && source.url && (
        <p className={styles.source}>
          Source:{" "}
          {(source.url && (
            <a href={source.url} target="_blank" rel="noopener noreferrer">
              {source.label}
            </a>
          )) || <span>{source.label}</span>}
        </p>
      )}
      {type !== "polling" && (
        <div className={styles.stats}>
          {(statsLoading && (
            <p>
              Loading response stats<span className={styles.loadingDot}>.</span>
              <span className={styles.loadingDot}>.</span>
              <span className={styles.loadingDot}>.</span>
            </p>
          )) ||
            (statsError.length === 0 && (
              <p>
                {stat1}% of quiz takers answered this correctly, out of {stat2}{" "}
                total responses.
              </p>
            )) || <p className={styles.error}>{statsError}</p>}
        </div>
      )}
    </motion.div>
  )
}
